export default __webpack_public_path__ + "static/media/xdcSamurai.e9b37b39.png";